import React from 'react'
import { MenuItem, Typography, ListItemText, styled } from '@mui/material'
import { Icon } from 'packages/eid-icons'
import { useTranslation } from 'react-i18next'

const StyledMenuItem = styled(MenuItem)({
    '&': {
        minWidth: '160px',
        fontSize: '13px',
        position: 'relative',
        minHeight: '40px',
        height: '50px',
    },
    '& .Mui-selected': {
        color: '#0057A0',
        backgroundColor: 'rgba(48, 127, 193, 0.07) !important',
        borderLeft: '2px solid #0057A0',
        '& img': {
            opacity: 1,
            filter: 'grayscale(0%) ',
        },
    },
})

const StyledTypography = styled(Typography)({
    color: '#aab0b4',
    fontSize: '12px',
    marginRight: '8px',
})

const SortingMenuItem = ({ displayName, selected, onClick, order }) => {
    const { t } = useTranslation()

    return (
        <StyledMenuItem onClick={onClick} selected={selected}>
            <ListItemText>{displayName}</ListItemText>

            {selected && (
                <>
                    <StyledTypography>
                        {order === 'asc' ? t('A-Z') : t('Z-A')}
                    </StyledTypography>

                    <Icon
                        name="ArrowLong"
                        width="16px"
                        height="16px"
                        color="#0057A0"
                        direction={order === 'asc' ? 'down' : 'up'}
                    />
                </>
            )}
        </StyledMenuItem>
    )
}

export default SortingMenuItem
